import {AppActionsTypes} from "../interfaces/app";
import {AnyAction} from "@reduxjs/toolkit";

interface IAppState {
  rates: { [code: string]: number }
}

const initial: IAppState = {
  rates: {}
}

export const App = (state = initial, action: AnyAction) => {
  switch (action.type) {
    case AppActionsTypes.RATES:
      return {
        ...state,
        ...{
          rates: action.payload
        }
      };
    default:
      return state
  }
}